<div id="page-dev-services">

    <div class="page-section-header section-header">
        <p>Services</p>
    </div>
    
    <div class="page-section-container">

        <div class="page-section-row services-row">

            <div class="page-info-container">
                <img src="assets/Angular.png" alt="Frameworks" />
            </div>

            <div class="page-info-container">
                <img src="assets/Microsoft.png" alt="Frameworks" />
            </div>

            <div class="page-info-container">
                <img src="assets/AWS.png" alt="Frameworks" />
            </div>

            <div class="page-info-container">
                <img src="assets/SQL.png" alt="Frameworks" />
            </div>

            <div class="page-info-container">
                <img src="assets/Server.png" alt="Frameworks" />
            </div>
        </div>
    </div>
</div>
